enum BubbleType {
  Biomass = "bg-green-400",
  Consumers = "bg-purple-400",
  Design = "bg-red-400",
  Environmental = "bg-emerald-400",
  Implementation = "bg-cyan-400",
  Micropolluants = "bg-blue-400",
  ScientificAdvices = "bg-rose-400",
  Urine = "bg-yellow-400",
}

const bubbles_data = [
  {
    title: "Thibaud Sauvageon",
    type: BubbleType.Biomass,
    text: `
**Interviewee**: Thibaud SAUVAGEON is a scientific mediator, he made a thesis about the valorization of hemp fibers from abandoned soils and materials.

**Aim of the meeting**: We talked about our way to revalorize Clean Heat biomass.

**Key points**:
- He works on wood revalorization such as reusing the biomass in polluted ground in Lorraine making the soil unusable for cultivation.

- If we could use plants to grow in this environment and harvest the heavy metals in the ground, we could use the ground to cultivate food again or create textile by using hemp.

- It correlates with the application of Clean Heat to a certain extent.

- Our project becomes really interesting with the revalorization of our biomass in the water.

- In chemistry, they are particularly interested in amine function because it can be reused as fertilizers.

- If we test what kind of molecule we could reuse from our biomass, we will know what target we could aim for.

**After the interview**: We then proceeded to study what we could do with our microalgae biomass, and we saw great opportunities in the revalorization as biofuels. It was then our plan to contact scientists working on biomass revalorization and find partners to analyze what could be done with our strains, however we were too short in time.
    `,
  },
  {
    title: "Arthur Gonzalez",
    type: BubbleType.Consumers,
    text: `
**Interviewee:** He lives in Oasis du Carla, a french autonomous eco-village, composed of people reunited by the drive to live in a greener way and to have a positive impact on their environment.

**Aim of the meeting:** Understand if our system can address needs in such organization as eco-village.

**Key points:**
- Their heating solution should meet their budget : what if thanks to our device they would be able to make mony by selling biomass to biofuel industry ?

- We have to check if our system not only have a neutral impact, but if we can have a postive impact on the environment.

- Find other type of degradation pathway adaptable to our system would be a good asset to tackle the community main pollution

**After the interview:** We decided to contact stakeholders in the biofuel industry to see if we can have a positive impact, by revalorizing our biomass into making biofuel. Morever, we have looked for a solution to calculate our carbon footprint.
`,
  },

  {
    title: "Cindy Delvoye",
    type: BubbleType.Consumers,
    text: `
**Interviewee :** She is the policy officer to the Deputy Director General of the Villejuif city, France

**Aim of the meeting :** Discuss the city's renewable energy and wastewater projects and needs to understand them better.

**Key points of the meeting :**
- Cities are facing an energy crisis in addition to difficulties in purifying water. New solutions are generally not cost-effective enough, and not very responsible.

- The city of Villejuif is mainly heated by geothermal energy. Unfortunately, this solution is not cost-effective enough for individual households, and the city is looking for new responsible heating solutions.

- Clean Heat could therefore be implemented in individual households, where the solutions of traditional heating systems have a low profitability.

**After the interview:** We then proceeded to research about implementation to design our prototype.
    `,
  },

  {
    title: "Sabine Romon, Marion Guiet & Elisabeth Lehec",
    type: BubbleType.Consumers,
    text: `
**Interviewee :** Resilience, Foresight, Research and Innovation division of the new Ecological and Climate Transition Department.

**Aim of the meeting :** Understand the challenges of the ecological transition of a capital such as Paris, regarding water treatment and heating of buildings.

**Key points of the meeting :**

- The ZAC de Saint Vincent de Paul in Paris uses urine-separated toilets, which are coupled with a carbon filter for a depolluting action. - The interest of a urine revalorization solution is to set up a short circuit that is useful to nearby farmers or cities for the maintenance of green spaces.

- The environmental cost and in particular the carbon footprint are important elements for the choice of new heating or water pollution control solutions in cities.

- The iGEM IONIS team will have to study the nutritional values of urine obtained through the Clean Heat project so that it can be used as an effective fertilizer

**After the interview :** We contacted urine revaluation specialists to evaluate the nutrional requirements for a fertilizer. We also did some research about urine-separated toilets and their implementation in buildings for our future urine revaluation cycle. We also started a carbon footprint analysis.
`,
  },
  {
    title: "Paul Goudeau",
    type: BubbleType.Design,
    text: `
**Interviewee :** Technical Sales Engineer, Synoxis Algae

**Aim of the meeting :** Understanding the challenges of microalgae culture.

**Key points of the meeting :**

- Microalgae mainly need a light source for photosynthesis (LEDs are the most suitable light sources because they provide more light than heat), as well as a source of nutrients, a CO2 input and a shaking movement.

- The culture can be done in a specialized device, called a photobioreactor, but can also be started in an erlenmeyer.

- A co-culture with a bacteria can be interesting for many properties.

- Microalgae can be fragile regarding their heat resistance ; this point could be improved in the Clean Heat project.

**After the interview :** We bought the required materials to build a setup for a microalgae culture. We also chose C. reinhardtii as our heat producer and implemented a co-culture advantageous for its heat resitance
    
    `,
  },
  {
    title: "Matthew Critchlow",
    type: BubbleType.Environmental,
    text: `
**Interviewee:** Head of sales of Climate Partner, an international company helping firms to calculatea and reduce their carbon impact

**Objective of the meeting :** Discuss about the possibilities and the methodology for the assessment of the carbon footprint

**Key points:**

- Heating is a major pollution source for individuals.

- The ADEM PAS method, akin to the greenhouse gas protocol for businesses, assesses carbon emissions.

- Key questions involve establishing a baseline scenario and comparing it with traditional heating methods.

- Emphasizing CO2 benefits is crucial, highlighting the disparity between Clean Heat and traditional heating.

- Developing a sound methodology is difficult due to the lack of an existing method, as data on carbon consumption and energy production are incomplete.

**After the interview :** [Results and critics]
`,
  },
  {
    title: "Claire Moras, Founder and Fanny Delamon",
    type: BubbleType.Implementation,
    text: `
**Interviewee :** The CESEAU is a non-profit frenchassociation for environmental education focused on water quality and protection. We had the pleasure to discuss with Claire Moras, Founder and Director of the CESEAU, and Fanny Delamon, Activity Coordinator.

**Aim of the meeting :** Dig deeper into real issues related to water quality in France, as well as explore the Clean Heat implementation options.

**Key points of the meeting :**

- The implementation of the Clean Heat system can be difficult in a wastewater treatment plant if it requires modifying existing processes. It would make more sense to focus on individual installations, which are easier to modulate.

- EE2, which comes from birth control pills, is a molecule found in urine before being released into wastewater into the environment.

- There are toilet systems that separate urine from feces. This option could be optimal to let the Clean Heat solution clean up urine without being disturbed by feces, which may have a consistency that would block the filters of the bioreactor as well as contain unwanted microorganisms.

- Urine can be revalued as biofertilizers for agriculture. This aspect can strengthen Clean Heat's circular and virtuous activity

**After the interview :** We studied the possibilities for the culture of our microorganisms in urines in order to degrade EE2 directly in urines. We also started the development of synthetic urines culture media to start the adaptation of C. reinhardtii and S. meliloti.
    `,
  },

  {
    title: "Forum eau",
    type: BubbleType.Implementation,
    text: `
**Place of meeting:** Water forum organized by the members and partners of the Eau Milieu Sol (EMS) cluster, held at the EPF engineering school in Cachan.

**Aim of the meeting:** talk with stakeholders and understand the issues concerning the water treatment globally

**Key points of the meeting:**

- We were able to discover many other projects and companies, such as Xylem, which produce water and wastewater treatment systems.

- We also had the chance to meet Ixsane, an environmental engineering consultancy, who had come to present their new research into heavy metal wastewater treatment, as well as their real-time equipment management software.

- By exchanging with different people, we could gain great information and ideas about Clean Heat.

- We had the opportunity to meet Artelia, who talked about grey water separation and their difficulties to separate azoted elements in grey water

- Waste Water Box that can clean water to make it drinkable.

- We also met Inovaya, a company specializing in chemical-free water treatment.

- Solaronics came to present their Factor 7 PAP systems. Like Clean Heat, they use domestic grey water discharge. Their system is coupled to a heat pump with two exchangers that transfer heat energy to mains water.

- BioStart saw potential in our project. They use a polymer (pure cytodextrin) to replace activated carbon and capture micropollutants in water, but their project doesn't work for soluble micropollutants like EE2.

**After the meeting:** With these interactions, we discover that our project is truly interesting for other companies for water treatment. We met people that encouraged us to develop our heating system too like BioStart. When they shared their projects with us, we identified potential challenges in the future. These challenges include the need to heat the water to at least 60°C for cleaning purposes, incorporating membranes as a security measure in our project, and exploring the possibility of reusing heavy metals.
`,
  },

  {
    title: "Double Science",
    type: BubbleType.Implementation,
    text: `
**Interviewee :** Public of the Double Science Festival in Paris, France - All ages combined

**Aim of the meeting :** Understand the challenges of a new heating and water purification solution in the eyes of potential individual consumers

**Key points of the meeting :**

- The Clean Heat solution should ideally be installed on existing heating or water treatment networks in order to limit costs

- The proposed system will have to be economically advantageous and reliable to support the use of heating for a family home

- Concerns have been raised about the use of GMOs and their potential release into the environment. The Clean Heat product will have to be safe in this regard.

**After the interview :** We studied the possibilities in terms of safety of our system. For example, we looked at sub-micron filters as well as different kill-switches.
`,
  },
  {
    title: "ECODOMEO",
    type: BubbleType.Implementation,
    text: `
**Interviewee:** Emanuel MORIN, director of ECODOMEO. ECODOMEO is a company designing dry toilets in France.

**Aim of the interview:** To explain to us how the dry toilets work and give us details of how we could integrate the process.

**Key points of the meeting:**

- Basically, the mechanism works to separate via a band, the urine and the excrement.

- Since urines are in contact with the excrements, pathogenic organisms are inside the urine.

- Thus, they stock the urines for at least 2 months. The WHO suggests 6 months even if 2 months are sufficient.

- They argue that the first limiter for their project of dry toilets are the current trend of casual toilets France and Europe in general possess.

- Because of that urine is not revalorized and we can find phosphate and azote as huge pollutants.

- They wish to put a carbon filter to collect the extra phosphate and azote to create fertilizer.

- Urines brings about 80% of azote and 70% of phosphate so it could be a huge gain if it was possible to harvest it safely.

- For them, adding a photobioreactor in the process is possible.

**After the interview:** Technically speaking Clean Heat could be integrated into their project because bacteria would cost less than carbon filters and by using ammonia in the urine, we can create fertilizers
`,
  },
  {
    title: "Virginie MAISONNAVE",
    type: BubbleType.Implementation,
    text: `
**The interviewee:** Virginie MAISONNAVE, researcher at VEOLIA, one of the leaders of water depollution in France.

**Aim of the meeting:** We wanted an expert to judge our project.

**Key points of the meeting:**
- First problem encountered with the microalgae culture to treat water is that we will need a huge surface if we want to use sunlight

- It would be more and more difficult with the scale if we had the bacteria because the microalgae need more space than the bacteria.

- In order to protect and conserve the bacteria and the microalgae, it would be that they both are in optimal conditions for each other.

- Installing Clean Heat in water treatment plants is a good idea however, the problem with those water treatment plants is that every step is complex, and the process cannot be modified easily.

- In the best world we could change the process of treatment within 10 years, because we need to have the same efficiency of what they are doing, with the same flow rate.

- Even though We know we need to treat the hormones inside the water, it cannot be done with disregard of azote, phosphor, and carbon residues.

- However, she told us that the idea of working on urine with separation toilets is great because even if there are a few groups working on it (INRA Narbonne/INSA Toulouse), it could help turning the tables on the way we use toilet.

- The inconvenience she found out was that all the interactions with the synthetic effluents are not the same.

- If we want to advance on our project, we should try synthetic wastewater and urine environment.

- By making our microorganisms used to the environment they will be in, it will facilitate their development.

**After the interview:** We studied different implementation ideas and started to think about developing synthetic urines and wastewater to grow our microorganisms to decipher whether they survive in those environments or not.
    `,
  },
  {
    title: "Julien Leroux",
    type: BubbleType.Micropolluants,
    text: `
**The interviewee:** Julien LEROUX is a lecturer in the laboratories of the ParisTech and UPEC engineering schools. He is currently working on water pollution.

**Aim of the meeting:** We wanted to know how we could determine the concentration of EE2 inside our tests and receive some intels concerning the implementation of Clean Heat and how to reuse our biomass.

**Key points of the meeting:**

- EE2 is difficult to analyze so we want to use HPLC-MS/MS to analyze the concentration inside the tests, since it can find presence of molecules at the concentration of ng/L.

- However, it is hard to find a place where we could use HPLC-MS/MS since it is a really precise instrument.

- It would be easier to use HPLC-UV instead. However, we must use higher concentration

- It would be interesting to retrieve the nitrate and phosphate

- To find out the concentration we could use colorimetry or ionic chromatography

- Concerning the implementation inside a water treatment plant, he told us there is a huge debacle whether we should centralize the equipment or not.

- He personally thinks it would be preferable to centralize all the equipment

**After the meeting:** We then proceeded to look for HPLC-UV to measure concentrations of EE2 in our tests. Moreover, more and more scientists tell us that development in urine should be interesting.
    `,
  },

  {
    title: "Peter Vanrolleghem",
    type: BubbleType.Micropolluants,
    text: `
**Interviewee :** Prof. Peter Vanrolleghem, member of the Canadian Research Chair in Water Quality Modelling, and Professor in the Department of Civil and Water Engineering at Université Laval (Québec, Canada).

**Aim of the meeting :** Definition of the risk generated by EE2 - and more generally micropollutants - for biodiversity; Discussion about existing solutions to measure and decrease EE2 concentration in the environment.

**Key points of the meeting :**

- EE2 affects the ecology of rivers, including fish fertility by generating the feminization of animals.

- This endocrine disruptor is poorly degraded; 50% of the molecules pass through the treatment plants and are found in waterways.

- EE2 will persist in the environment as long as society has the utility of this molecule in the medical field.

- Current means to fight EE2 pollution are complex to implement, expensive and mostly ineffective. Carbon filters, for example, must be imported and maintained regularly before being burned, releasing toxic compounds into the atmosphere.

- PFAS are another example of dangerous micropollutants that have been proven to be carcinogenic.

- The measurement of EE2 concentration can be carried out using the HPLC method, or indirectly by using EE2-sensitive yeasts to measure its endocrine effect.

- It is important to completely degrade EE2, and not to chemically deconjugate it, because this phenomenon can lead to a recombination that gives rise to a polluting molecule again.

**After the interview :** After meeting Prof. Peter Vanrolleghem, we chose HPLC to measure EE2 concentration. We also thought about the future of Clean Heat : by the implementation of other genes, we could potentially degrade other molecules, such as PFAS. This would make Clean Heat an even more complete system for cleaning up water. For urines, we also thought about degrading drugs and antibiotics.
    
    `,
  },

  {
    title: "Sandrine Alfenore",
    type: BubbleType.ScientificAdvices,
    text: `
**Interviewee :** Dr Alfenore, lecturer at INSA Toulouse, reasearcher about the rise of density in microbial process

**Key points of the meeting:**

· Bioreacteur and such biological process consumme lot of water it is essential to take in account our water consumption in our system. Indeed with climate change water is going to be even more precious

· To dertemine why our microoganims are not able to grow quickly in synthetic urine/ wastewater we should do a Carbone, Phospahte, Nitrogen balance and compare it with TAP media

· Using membrane to seperate our microorganism in the photobioreactor is a good idea however it will require more energy to put pressure in our system and make nutrients go through the membrane

· Regarding the water issues our system answer to the current problematic since we are not using water, we are revaluing wastewater and help to make it usable for other application

**After the interview :** We studied the possibilities to carry out a Carbone, Phospahte, Nitrogen balance. We also included the water consumption and pressure topics to our photobioreactor model.
    `,
  },
  {
    title: "Yves Choquet",
    type: BubbleType.ScientificAdvices,
    text: `
**Interviewee :** Ph.D. Assistant Director at Institute of Physico-Chemical Biology UMR7141 (CNRS/SU) – Chloroplast Biology and Light Perception in Microalgae

**Aim of this meeting:** Understand the growth conditions of C.reinhardtii and to know the opinion of a scientist working on our selected microorganims about our project

**What we learned :**

· Reducing equivalents might be necessary for the thermogenic properties

· Thioredoxins might be important

· Chlamydomonas has a really high level of CG content so it is important to do codon optimization

· Might experience some difficulties to measure the temperature, thermometer measure might be influenced by the light and waterproof calorimeter are in dark box which is incompatible with the light required for C. reinhardtii

· No need to add CO2 for our culture even though growth won’t be optimal

**After the interview :** We had a meeting with individuals working on thioredoxin. We focused on codon optimization during our discussions. We designed experiments to observe the effects of NADH. Additionally, we planned experiments to measure temperature accurately.
    `,
  },
  {
    title: "Kikukatsu Ito",
    type: BubbleType.ScientificAdvices,
    text: `
**Interviewee :** Ph.D. Professor at Iwate University

** Aim of the exchange:**  Understand better the functionning of SrAOX, the thermogenic protein we wanted to put in our microalgae

**Key points of the meeting:**

· It is essential to use activators to enhance the thermogenic properties with several molecules such as alfa-keto acids and high levels of reducing equivalents, such as NADH or reduced thioredoxin.

· Would be better to use a strong promoter

· We should be careful about gene / codon optimization for our microorganism

**After the interview:** Contact scientist working on o thioredoxin to know if we have to add the gene encoding for this protein in C.reinhardtii
    `,
  },
  {
    title: "Nicolas Rouhier",
    type: BubbleType.ScientificAdvices,
    text: `
**Interviewee:** Ph.D. Professor at Iwate University

**Aim of the interview:** Determine if the add of thioredoxin encoding gene is necessary to our prototype

**Key points of the meeting:**

· AOX activation seems to not be linked to reduction in in vivo study despite the fact it has been proved that in vitro thioredowin activates SrAOX proteins.

· As AOX proteins are activated by stress it is more likely that oxydation activate their activity

· We should be careful, C. reinhardtii do lot of gene silencing, to avoid this it is essential to optimize the gene with introns

**After the interview:**

· Knowing that C.reinhardtii alreay expressed thioredoxin proteins and that they might not be essential for AOX activation we decided to not add a gene encoding for them in our microalgae

· We adapted the design of our AOX gene to add introns inside
    `,
  },

  {
    title: "Zoran Marinkovic",
    type: BubbleType.ScientificAdvices,
    text: `
**Interviewee:** Zoran MARINKOVIC is a postdoctoral associate at the New York university working on the interactions between cancer cells and their microenvironment, including T-cells and immunotherapy.

**Aim of the meeting:** Knowing he was also a jury for iGEM, we asked him a few questions about what we should focus on the project.

**Key point of the meeting:**

- He said it was very important to have a prototype, such a feat would represent a huge amount of work but show how far we can get to be in the planification of our project.

- Human practices are very important to have. Strong human practices show the determination and curiosity we have in the scientific field in addition to having experts giving their point of view on our project. Stakeholders always have a better understanding of the whole environment of development, they can highlight problems we couldn’t think of.

- We must do the optimization of our parts. We must change the sequences because doing Codon optimization is not enough, we need to, at least, change the promoter or the RBS.

- To prove that we improved the part we need a negative control with the original part.

- The wiki must be as clear as possible. Making a clear wiki is as important as being full of information. Judges must read a lot of wikis, making their task easier is a good way to gain the upper hand.

- It is mandatory to document our parts correctly (sequence, results associated, background).

- It is important to not make the presentation too specific, not all judges are experts about our project. Everybody should be able to fully appreciate the content of our presentation.

**After the meeting:** We then put extra care toward human practices and our lab method in order to target accurately iGEM requirements.

    `,
  },

  {
    title: "Louise Raguet",
    type: BubbleType.Urine,
    text: `
**Interviewee:** Designer and creator of women's urinals Marcelle, manager of the ENVILLE project : Citizen solution of agricultural valorization of human urine : an action research project of the Ocapi program (École des Ponts Paris-Tech).

**Aim of the meeting:** Understand the challenges of urine valorization and the implementation of the Clean Heat solution.

**Key points of the meeting :**

- The revaluation of urine requires the removal of certain pollutants in addition to drug molecules such as EE2. The concentration of nitrogen, phosphorus and potassium, present in large quantities in wastewater and urine in general, must be reduced to ensure proper reuse of urine.

- Nitrification is a process usually used to transform nitrogen from ammonia to nitrate, preferable for fertilizer.

- Bacteria can be used to perform this step; it may be wise to integrate nitrification into the Clean Heat system to make it a more complete solution and allow a better recovery of urine products.

- Urine collection is a sensitive action, subject to social acceptability. It will be necessary to establish educational support and explain the benefits of this type of solution, in order to avoid the release of toxic compounds (such as bleach) usually used for maintenance but which can be harmful to Clean Heat organisms.

**After the interview:** We decided to study the reduction of the concentration of nitrogen, phosphorus and potassium by our system to ensure a good urine revaluation. This step can also help us decide if we need to implement a nitrification solution to our system.
`,
  },

  {
    title: "Mathieu Sperandio",
    type: BubbleType.Urine,
    text: `
**Interviewee :** Professor at INSA Toulouse, France, and responsible for a research team on bioprocesses for the purification and recovery of waste and wastewater.

**Aim of the meeting :** Understanding the challenges of revalorizing nutrients present in urine.

**Key points of the meeting :**

- There are different processes for revalorizing nutrients in urine. Some are difficult to implement, and can be very expensive. The Clean Heat project will need to ensure that efficient and cost-effective methods are used.

- If necessary, water may be present in the final solution because the revalued urine is not always used at the initial concentration.

- Carbon filters are a good depollution solution, but must be imported, renewed regularly, and then burnt. Clean Heat must be more efficient and responsible than activated carbon-based solutions.

- Microalgae form a biomass that can be recycled into biofuel. They can also be revalued through protein production. these aspects are to be studied by the iGEM IONIS team in order to improve the added value of the Clean Heat project.

**After the interview :** We decided to include a costs study in our prototype production process. For the future of the project, we also decided to compare Clean Heat’s carbon footprint to other cleaning solutions’ones to make sure our system has less negative impact –or to continue reducing it-. We finally studied protein production based on microalgae biomass to add a perspective to Clean Heat’s future circular economy.
`,
  },

  {
    title: "David de Chambrier",
    type: BubbleType.Urine,
    text: `
**Interviewee:** Co-founder of VunaNexus, located in Zurich.

**Aim of the interview:** We want to know how we can revalorize urine and the issues linked to this objective.

**Key points of the interview:**

- Their project is to reuse urine and transform it into fertilizers.

- We already had some idea about reusing it as fertilizer.

- M. de CHAMBRIER talked about his use of liquid fertilizers.

- It would be easier to use Clean Heat biomass since our microorganisms are in liquid solvent.

- They explained the problem they encounter is that in plantation fields, they do not possess installations to spread liquid fertilizers since it is normally solid, however it could be a good opportunity for privates or cities.

- M. de CHAMBRIER also pointed out that if we want to dive into the use of urine, we should integrate other urine processes to form teams, like that we could have more support from the same community.

**After the interview:** We then proceeded to look for other groups of research that are developing new way to reuse water for future development.
`,
  },
];

export { BubbleType, bubbles_data };
